import { HTMLProps, forwardRef } from 'react';
import styled from 'styled-components';
import { s16 } from '@ardoq/design-tokens';
import { Header4 } from '@ardoq/typography';
import { ArdoqLoaderComponent } from './ArdoqLoaderComponent';
import { LoaderColor, LoaderSize } from './consts';

const OverlayWrapper = styled.div<{ $enabled: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & > img {
    height: 10px;
    margin-bottom: ${s16};
  }
  opacity: ${props => (props.$enabled ? 1 : 0)};
  pointer-events: ${props => (props.$enabled ? 'auto' : 'none')};
  transition: opacity 300ms ease-out;
  animation-duration: ${props => (props.$enabled ? '1s' : '0s')};
  animation-timing-function: ease-in;
  animation-name: ${props => (props.$enabled ? 'fadeIn' : 'none')};
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const MessageWrapper = styled.div`
  margin-bottom: ${s16};
`;

type LoadingOverlayProps = Pick<
  HTMLProps<HTMLButtonElement>,
  'style' | 'className'
> & {
  message?: string | null;
  hideSpinner?: boolean;
  imgUrl?: string;
  loaderSize?: LoaderSize;
  enabled?: boolean;
};

export const LoadingOverlay = forwardRef<HTMLDivElement, LoadingOverlayProps>(
  (
    { message, hideSpinner, imgUrl, loaderSize, enabled = true, ...divProps },
    ref
  ) => (
    <OverlayWrapper {...divProps} ref={ref} $enabled={enabled}>
      {imgUrl ? (
        <>
          {message && (
            <MessageWrapper>
              <Header4 color="textDefault">{message}</Header4>
            </MessageWrapper>
          )}
          {!hideSpinner && <img src={imgUrl} />}
        </>
      ) : (
        <ArdoqLoaderComponent
          size={loaderSize || LoaderSize.LARGE}
          loaderColor={LoaderColor.BRAND}
          loaderText={message}
          hideSpinner={hideSpinner}
        />
      )}
    </OverlayWrapper>
  )
);
